import { render, staticRenderFns } from "./NewPortfolioCards.vue?vue&type=template&id=28d94425&scoped=true&"
import script from "./NewPortfolioCards.vue?vue&type=script&lang=js&"
export * from "./NewPortfolioCards.vue?vue&type=script&lang=js&"
import style0 from "./NewPortfolioCards.vue?vue&type=style&index=0&id=28d94425&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d94425",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
